import { triggerNames } from '@/data/events/triggers';

const globalTriggers = [
    triggerNames.CLICK,
    triggerNames.MOUSEENTER,
    triggerNames.MOUSELEAVE,
    triggerNames.VIEW,
    triggerNames.LOAD,
    triggerNames.COLLECTION_LOAD,
    triggerNames.FLEX_EVENT,
];

function getTriggers(add = [], remove = []) {
    return globalTriggers.concat(add).filter(t => !remove.includes(t));
}

// if you need to restrict which triggers are available to certain elements, you can do so here
// one prop per elementType
export default function getTriggerMapping(elementType) {
    switch (elementType) {
        case 'a-checkbox':
        case 'a-radio-button':
        case 'a-input':
        case 'a-select':
        case 'a-textarea':
            return getTriggers([triggerNames.CHANGE]);

        case 'o-form-container':
            return getTriggers([triggerNames.SUBMIT]);

        default:
            return globalTriggers;
    }
}
